import store from '../store/index';
import { actions } from '../store/reducers/toasts';

export default class ErrorService {
  static handle({ status, statusText, data }) {
    store.dispatch(actions.addToast({
      title: statusText,
      type: 'danger',
      body: this.formatData(data)
    }));
  }

  static formatData(errors) {
    const e = []
    errors.forEach(error => {
      Object.keys(error.constraints)
        .forEach(key => e.push(error.constraints[key]));
    });
    return e.join('\n');
  }
}